// extracted by mini-css-extract-plugin
export var swiper = "ClientsSwiper-module--swiper--WfoaF";
export var swiper__slide = "ClientsSwiper-module--swiper__slide--ZHogy";
export var swiper__slide__title = "ClientsSwiper-module--swiper__slide__title--PvSf3";
export var wrapper = "ClientsSwiper-module--wrapper--b4Ib6";